import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { axiosBaseInstance } from "../../data";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import LandscapeIcon from '@mui/icons-material/Landscape';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import StackedColumnChart from "../PhiChart";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const modalStyle = {
  outline: "none",
  position: "absolute",
  top: "50%",
  left: "50%",
  minHeight: "25%",
  transform: "translate(-50%, -50% )",
  width: "60%",
  minWidth: "500px",
  borderRadius: 1,
  bgcolor: "background.paper",
  p: 4,
};

const VolUploadModal = ({ modalOpen, closeModal, openModal }) => {
  const [base, setBase] = useState(null)
  const [ogl, setOgl] = useState(null)
  const [shp, setShp] = useState(null)
  const [coords, setCoords] = useState([])
  const [vols, setVols] = useState([null, null])
  const [wVols, setWVols] = useState([null, null])


  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('base', base);
    formData.append('ogl', ogl);

    try {
      const res = await axiosBaseInstance.post('/temp-vol', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      // console.log(res.data);

      setVols(res.data);
      if (shp) {
        await readCoordsFromPoly(shp)
      }
    } catch (err) {
      console.error(err);
    }
  };

  const readCoordsFromPoly = async (_event) => {
    const formData = new FormData();
    formData.append("poly", shp);

    try {
      const resp = await axiosBaseInstance.post(`/uploadShp`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      const result = await resp.data;
      setCoords(result.coordinates)
      // drawPolygonFromPoints(result.coordinates)
    } catch (error) {
      console.log(error.message);
    }
  }

  const calculateVolumeWithinSegmet2 = async () => {

    try {
      const bodyy = {
        polys: coords
      }

      const resp = await axiosBaseInstance.post(`/segment/within2`, bodyy, {
        headers: {
          "Content-Type": "application/json"
        }
      })

      const result = await resp.data;
      setWVols(result)
      console.log("segmented vol, ", result);
    } catch (error) {
      console.log(error.message)
      setWVols([null, null])
    }
  }

  useEffect(() => {
    return () => {
      setBase(null)
      setOgl(null)
      setVols([null, null])
    }
  }, [])
  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        closeModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ ...modalStyle, width: "60%", backgroundColor:"var(--primary-2)", border:"1px solid var(--color-border)" }}
      >
        <div style={{ display: "flex", justifyContent: "center", gap: "50px" }}>
          <div style={{ display: "flex", flexDirection: "column", flex: 1, gap: 20 }}>
            <div>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                sx={{
                  backgroundColor: base ? 'var(--primary-1)' : 'var(--primary-2)',
                  '&:hover': {
                    backgroundColor: 'grey',
                  },
                }}
              >
                Upload a Ground Level TIF
                <VisuallyHiddenInput
                  type="file"
                  name="base"
                  onChange={(event) => setBase(event.target.files[0])}
                  multiple
                />
              </Button>
            </div>
            <div>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                sx={{
                  backgroundColor: ogl ? 'var(--primary-1)' : 'var(--primary-2)',
                  '&:hover': {
                    backgroundColor: 'grey',
                  },
                }}
              >
                Upload OGL TIF
                <VisuallyHiddenInput
                  type="file"
                  name="segment"
                  onChange={(event) => setOgl(event.target.files[0])}
                  multiple
                />
              </Button>
            </div>
            <div>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                sx={{
                  backgroundColor: shp ? 'var(--primary-1)' : 'var(--primary-2)',
                  '&:hover': {
                    backgroundColor: 'grey',
                  },
                }}
              >
                Upload Polygon (Optional)
                <VisuallyHiddenInput
                  type="file"
                  name="segment"
                  onChange={(event) => setShp(event.target.files[0])}
                  multiple
                />
              </Button>
              &nbsp;<button className="btn btn-dark" disabled={coords.length === 0} onClick={calculateVolumeWithinSegmet2}>Get</button>
            </div>
            <button className="btn btn-dark" onClick={handleSubmit} >Upload & Calculate</button>
          </div>
          {
            vols && vols.length > 0 && vols[0] !== null && vols[1] !== null ?
              
                // vols && vols.length > 0 && vols[0] !== null && vols[1] !== null &&
                // vols[0] === false ? <p style={{ color: "red" }} align="center">Something went wrong!</p> :
                <StackedColumnChart cutSeg={vols[0].toFixed(2)} fillSeg={vols[1].toFixed(2)} 
                cutPoly={wVols && wVols[0] ?  wVols[0]?.toFixed(2):0} 
                fillPoly={wVols && wVols[1] ? wVols[1]?.toFixed(2):0} />

              // <div
              //   className="container rounded"
              //   style={{
              //     display: "flex",
              //     flex: 1,
              //     flexDirection: "column",
              //     justifyContent: "center",
              //     alignItems: "center",
              //     background: "pink"
              //   }}
              // >
              //   <div>
              //     <strong>Segment Volumes</strong>
              //     <div id="display-volume" className="label" style={{ display: "flex", justifyContent: "space-between" }}>
              //       {
              //         vols[0] === false ? <p style={{ color: "red" }} align="center">Something went wrong!</p> :
              //           <>
              //             <span style={{ color: "red" }}>cut</span>: {vols[0].toFixed(2)} m&sup3; &nbsp; <br />
              //             <span style={{ color: "green" }}>fill</span>: {vols[1].toFixed(2)} m&sup3; &nbsp; <br />
              //             <span style={{ color: "grey" }}>total</span>: {(vols[0] + vols[1]).toFixed(2)} m&sup3; &nbsp;
              //           </>
              //       }
              //     </div>
              //   </div>
              //   {wVols && wVols.length > 0 && wVols[0] !== null && wVols[1] !== null && <div>
              //     <strong>Polygon Volumes</strong>
              //     <div id="display-volume" className="label" style={{ display: "flex", justifyContent: "space-between" }}>
              //       {
              //         wVols[0] === false ? <p style={{ color: "red" }} align="center">Something went wrong!</p> :
              //           <>
              //             <span style={{ color: "red" }}>cut</span>: {wVols[0].toFixed(2)} m&sup3; &nbsp; <br />
              //             <span style={{ color: "green" }}>fill</span>: {wVols[1].toFixed(2)} m&sup3; &nbsp;<br />
              //             <span style={{ color: "grey" }}>total</span>: {(wVols[0] + wVols[1]).toFixed(2)} m&sup3; &nbsp;
              //           </>
              //       }
              //     </div>

              //   </div>}
              // </div>
              :
              <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <LandscapeIcon />
                <h5>
                  Select Files
                </h5>
              </div>
          }
        </div>
      </Box>
    </Modal>
  )
}

export default VolUploadModal
